import { render, staticRenderFns } from "./GrupaStatusaEdit.vue?vue&type=template&id=dedb15c0&scoped=true&"
import script from "./GrupaStatusaEdit.vue?vue&type=script&lang=js&"
export * from "./GrupaStatusaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedb15c0",
  null
  
)

export default component.exports